export class GetServiceOrderRequestBody {
  dmsServiceOrderId: string;
}

